let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6aYtx")).then(() => parcelRequire('ioMWp'));